var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullscreenFrontageDialog',{ref:"frontageDialog",scopedSlots:_vm._u([{key:"default",fn:function(dialogProps){return [_c('NewNoteDialog',{attrs:{"is-mobile":_vm.isMobile,"is-entity":dialogProps.isEntity,"matter-uid":_vm.matterUid,"note-uid":_vm.noteUid},on:{"handle-close":_vm.handleClose,"handle-submit":_vm.handleSubmit}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }